import { render, staticRenderFns } from "./NewMailAccountDialog.vue?vue&type=template&id=ba46052a&scoped=true&"
import script from "./NewMailAccountDialog.vue?vue&type=script&lang=ts&"
export * from "./NewMailAccountDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewMailAccountDialog.vue?vue&type=style&index=0&id=ba46052a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba46052a",
  null
  
)

export default component.exports